var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2187 2.32846C13.984 0.957691 12.0335 1.51009 10.8618 2.39001C10.3814 2.7508 10.1412 2.93119 9.99987 2.93119C9.85854 2.93119 9.61833 2.7508 9.13791 2.39001C7.96622 1.51009 6.01577 0.957691 3.78107 2.32846C0.848258 4.12745 0.184635 10.0624 6.94948 15.0695C8.23797 16.0232 8.88221 16.5 9.99987 16.5C11.1175 16.5 11.7618 16.0232 13.0503 15.0695C19.8151 10.0624 19.1515 4.12745 16.2187 2.32846Z",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteNew);
export default __webpack_public_path__ + "static/media/favourite-new.3d19fa3db0e43237639285cc22579b16.svg";
export { ForwardRef as ReactComponent };